import NxsObserver, { trackers } from '@rmm/error-tracker';

if (window.loggingSettings && window.loggingSettings.enable) {
  const IS_LOGGING_ONLY_LEAD_MEDIA = window.loggingSettings?.onlyLeadMedia;
  const defaultLoggingParams = {
    id: IS_LOGGING_ONLY_LEAD_MEDIA ? 'player-lead-media' : 'general-task',
    position: IS_LOGGING_ONLY_LEAD_MEDIA ? 'Lead Media' : 'general-task',
    renderGroup: 'Initialization within WP',
  };

  const { SimpleErrorTracker } = trackers;
  window.errorTracker = NxsObserver;
  window.errorTrackerInstance = NxsObserver.getInstance(window.loggingSettings);

  const heartbeatTracker = new SimpleErrorTracker(
    'Heartbeat',
    100,
    defaultLoggingParams,
  );
  const selector = `script.${window.loggingSettings.settingsScriptHandle}`;
  const settingsScriptNode = document.querySelector(selector);
  if (settingsScriptNode && 'true' === settingsScriptNode.dataset.pixelHit) {
    heartbeatTracker.sendSuccess();
  } else {
    heartbeatTracker.sendError(new Error('Heartbeat pixel not hit'), 1);
  }

  // Dispatching detection of lead media video being present
  const videoCountOnPage = window.NXSTdata.content.videoCount;
  const hasLeadMediaTerm = window.loggingSettings.postHasLead;
  // eslint-disable-next-line max-len
  const leadMediaQuerySelector = '.article-container figure.article-featured-media--lakanaanvplayer';
  const leadMediaNodeExists = !! document.querySelector(leadMediaQuerySelector);

  const countTracker = new SimpleErrorTracker(
    'Heartbeat: Video count',
    100,
    defaultLoggingParams,
  );
  const termTracker = new SimpleErrorTracker(
    'Heartbeat: Lead media term',
    100,
    defaultLoggingParams,
  );
  const nodeTracker = new SimpleErrorTracker(
    'Heartbeat: Query selector',
    100,
    defaultLoggingParams,
  );
  if (0 < videoCountOnPage) {
    countTracker.sendSuccess();
  }
  if (hasLeadMediaTerm) {
    termTracker.sendSuccess();
  }
  if (leadMediaNodeExists) {
    nodeTracker.sendSuccess();
  }
}
window.trackerReady = true;

